import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import logoImage from '../assets/logo.jpg';
import pierluigiCopertina1 from '../assets/pierluigi_girolami_copertina1.png';
import emilianoBattanzi from '../assets/emiliano_battazzi_copertina1.png';
import pierluigiCopertina2 from '../assets/pierluigi_girolami_copertina2.png';
import pierluigiCopertina3 from '../assets/pierluigi_girolami_copertina3.png';
import pierluigiCopertina4 from '../assets/pierluigi_girolami_copertina4.png';
import fotoAntonella1 from '../assets/foto_antonella-1.JPG';
import fotoAntonella2 from '../assets/foto_antonella-2.JPG';
import fotoAntonella3 from '../assets/foto_antonella-3.JPG';
import fotoAntonella4 from '../assets/foto_antonella-4.JPG';
import fotoAntonella5 from '../assets/foto_antonella-5.JPG';
import fotoAntonella6 from '../assets/foto_antonella-6.JPG';
import fotoAntonella7 from '../assets/foto_antonella-7.jpg';
import fotoAntonella8 from '../assets/foto_antonella-8.jpg';
import fatimaCard from '../assets/Fatima_17.jpeg';
import fotoFamigliaFatima from '../assets/Foto_famiglia_Fatima.jpeg';
import fotoMonica from '../assets/Foto_La storia di Monica.jpg';
import fotoCinqueStorie from '../assets/Foto_Cinque_storie.jpg';
const ImageCarousel = ({ images, onOpenFullscreen }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  
  const goToPrev = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };
  
  const goToNext = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };
  
  return (
    <div className="relative">
      <div className="overflow-hidden rounded-lg">
        <div className="flex items-center justify-center">
          <img 
            src={images[currentIndex]} 
            alt={`Foto ${currentIndex + 1}`} 
            className="h-64 object-contain cursor-pointer"
            onClick={() => onOpenFullscreen(currentIndex)}
          />
        </div>
      </div>
      
      <div className="flex items-center justify-between mt-4">
        <button 
          onClick={goToPrev}
          className="bg-primary text-white w-10 h-10 rounded-full flex items-center justify-center hover:bg-primary/80 transition duration-300"
          aria-label="Foto precedente"
        >
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-5 h-5">
            <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
          </svg>
        </button>
        
        <div className="text-center">
          <span className="text-gray-600">{currentIndex + 1} / {images.length}</span>
        </div>
        
        <button 
          onClick={goToNext}
          className="bg-primary text-white w-10 h-10 rounded-full flex items-center justify-center hover:bg-primary/80 transition duration-300"
          aria-label="Foto successiva"
        >
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-5 h-5">
            <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
          </svg>
        </button>
      </div>
    </div>
  );
};

const FullscreenImageModal = ({ isOpen, onClose, images, initialIndex }) => {
  const [currentIndex, setCurrentIndex] = useState(initialIndex || 0);
  
  const goToPrev = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };
  
  const goToNext = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };
  
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!isOpen) return;
      
      if (e.key === 'ArrowLeft') {
        goToPrev();
      } else if (e.key === 'ArrowRight') {
        goToNext();
      } else if (e.key === 'Escape') {
        onClose();
      }
    };
    
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen]);
  
  if (!isOpen) return null;
  
  return (
    <div className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center">
      <button 
        onClick={onClose}
        className="absolute top-4 right-4 text-white hover:text-gray-300 transition-colors duration-300"
        aria-label="Chiudi"
      >
        <svg className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
      
      <button 
        onClick={goToPrev}
        className="absolute left-4 top-1/2 transform -translate-y-1/2 text-white hover:text-gray-300 transition-colors duration-300"
        aria-label="Foto precedente"
      >
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-10 h-10">
          <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
        </svg>
      </button>
      
      <div className="max-w-5xl max-h-screen p-4">
        <img 
          src={images[currentIndex]} 
          alt={`Foto ${currentIndex + 1}`} 
          className="max-h-[85vh] max-w-full object-contain"
        />
      </div>
      
      <button 
        onClick={goToNext}
        className="absolute right-4 top-1/2 transform -translate-y-1/2 text-white hover:text-gray-300 transition-colors duration-300"
        aria-label="Foto successiva"
      >
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-10 h-10">
          <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
        </svg>
      </button>
      
      <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 text-white">
        <span>{currentIndex + 1} / {images.length}</span>
      </div>
    </div>
  );
};

const Modal = ({ isOpen, onClose, title, children, primaryAction }) => {
  const modalRef = useRef(null);
  
  // Chiudi il modale quando si clicca fuori
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };
    
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);
  
  // Gestisce il tasto Escape per chiudere il modale
  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };
    
    if (isOpen) {
      document.addEventListener('keydown', handleEsc);
    }
    
    return () => {
      document.removeEventListener('keydown', handleEsc);
    };
  }, [isOpen, onClose]);
  
  if (!isOpen) return null;
  
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 p-0 sm:p-4">
      <div className="fixed inset-0 bg-black bg-opacity-75 transition-opacity"></div>
      <div 
        ref={modalRef}
        className="bg-white rounded-lg shadow-xl mx-auto z-10 transform transition-all ease-in-out duration-300 overflow-hidden"
        style={{ maxHeight: '95vh', width: '80%', maxWidth: '900px' }}
      >
        <div className="px-5 sm:px-6 md:px-8 py-4 border-b flex items-center justify-between">
          <h3 className="text-xl sm:text-2xl font-semibold text-primary">{title}</h3>
          <button 
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 focus:outline-none"
            aria-label="Chiudi"
          >
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="px-5 sm:px-8 md:px-10 py-8 overflow-y-auto" style={{ maxHeight: 'calc(95vh - 140px)', overflowX: 'hidden' }}>
          {children}
        </div>
        <div className="px-5 sm:px-8 md:px-10 py-4 border-t bg-gray-50 flex justify-end">
          {primaryAction}
        </div>
      </div>
    </div>
  );
};

const ImpactStory = ({ image, title, description, fullText, imageObjectPosition = "object-center", imageStyle }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isFullscreenOpen, setIsFullscreenOpen] = useState(false);
  const [fullscreenInitialIndex, setFullscreenInitialIndex] = useState(0);
  
  const handleOpenFullscreen = (index) => {
    setFullscreenInitialIndex(index);
    setIsFullscreenOpen(true);
  };
  
  return (
    <>
      <div className="bg-white rounded-lg shadow-md overflow-hidden">
        <img src={image} alt={title} className={`w-full h-48 object-cover ${imageObjectPosition}`} style={imageStyle} />
        <div className="p-4">
          <h3 className="text-xl font-bold text-primary mb-2">{title}</h3>
          <p className="text-gray-700 mb-4">{description}</p>
          {fullText && (
            <button 
              onClick={() => setIsModalOpen(true)}
              className="bg-primary text-white py-2 px-4 rounded-lg text-sm font-semibold hover:bg-primary/90 transition duration-300"
            >
              Leggi tutto
            </button>
          )}
        </div>
      </div>
      
      {fullText && (
        <Modal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          title={title}
          primaryAction={
            <button
              onClick={() => setIsModalOpen(false)}
              className="bg-primary text-white py-2 px-4 rounded-lg font-semibold hover:bg-primary/90 transition duration-300"
            >
              Chiudi
            </button>
          }
        >
          <div className="prose max-w-none">
            {fullText.split('\n\n').map((paragraph, index) => (
              <p key={index} className="mb-6 text-base md:text-lg text-gray-700" style={{ lineHeight: '1.8' }}>{paragraph}</p>
            ))}
            
            {title === "La storia di Pierluigi" && (
              <div className="mt-10 border-t pt-8">
                <h4 className="text-xl font-semibold text-primary mb-4">I libri di Pierluigi</h4>
                <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
                  <div className="book-cover">
                    <img 
                      src={pierluigiCopertina1}
                      alt="Libro di Pierluigi Girolami" 
                      className="h-48 object-cover rounded-md shadow-md hover:shadow-lg transition-shadow duration-300"
                    />
                  </div>
                  <div className="book-cover">
                    <img 
                      src={pierluigiCopertina2} 
                      alt="Libro di Pierluigi Girolami" 
                      className="h-48 object-cover rounded-md shadow-md hover:shadow-lg transition-shadow duration-300"
                    />
                  </div>
                  <div className="book-cover">
                    <img 
                      src={pierluigiCopertina3}
                      alt="Libro di Pierluigi Girolami" 
                      className="h-48 object-cover rounded-md shadow-md hover:shadow-lg transition-shadow duration-300"
                    />
                  </div>
                </div>
              </div>
            )}
            
            {title === "La storia di Antonella" && (
              <div className="mt-10 border-t pt-8">
                <h4 className="text-xl font-semibold text-primary mb-4">Le foto di Antonella</h4>
                <p className="text-gray-700 mb-6">La fotografia è la mia passione, un modo per catturare e condividere la bellezza del mondo. Ecco alcune delle mie foto. Clicca su un'immagine per ingrandirla.</p>
                <ImageCarousel 
                  images={[
                    fotoAntonella1, 
                    fotoAntonella2, 
                    fotoAntonella3, 
                    fotoAntonella4, 
                    fotoAntonella5, 
                    fotoAntonella6, 
                    fotoAntonella7, 
                    fotoAntonella8
                  ]} 
                  onOpenFullscreen={handleOpenFullscreen}
                />
              </div>
            )}
            {title === "La storia di Emiliano" && (
              <div className="mt-10 border-t pt-8">
                <h4 className="text-xl font-semibold text-primary mb-4">Il libro di Emiliano</h4>
                <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
                  <div className="book-cover">
                    <img 
                      src={emilianoBattanzi}
                      alt="Libro di Emiliano Battazzi" 
                      className="h-48 object-cover rounded-md shadow-md hover:shadow-lg transition-shadow duration-300"
                    />
                  </div>
                </div>
              </div>
            )}
            {title === "La storia di Fatima" && (
              <div className="mt-10 border-t pt-8">
                <h4 className="text-xl font-semibold text-primary mb-4">La famiglia di Fatima</h4>
                <div className="flex justify-center items-center">
                  <img 
                    src={fotoFamigliaFatima}
                    alt="Famiglia di Fatima" 
                    className="max-h-96 object-contain rounded-md shadow-md"
                  />
                </div>
              </div>
            )}
          </div>
        </Modal>
      )}
      
      {/* Fullscreen Image Modal */}
      {title === "La storia di Antonella" && fullText && (
        <FullscreenImageModal 
          isOpen={isFullscreenOpen}
          onClose={() => setIsFullscreenOpen(false)}
          images={[
            fotoAntonella1, 
            fotoAntonella2, 
            fotoAntonella3, 
            fotoAntonella4, 
            fotoAntonella5, 
            fotoAntonella6, 
            fotoAntonella7, 
            fotoAntonella8
          ]}
          initialIndex={fullscreenInitialIndex}
        />
      )}
    </>
  );
};

const ChiSiamo = () => {
  const location = useLocation();

  // Scorre alla sezione richiesta da un'altra pagina (es. il pulsante "Scopri le Storie di Impatto" in Sostienici)
  useEffect(() => {
    if (!location.state?.scrollTo) return;

    const timer = setTimeout(() => {
      const target = document.getElementById(location.state.scrollTo);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      // Evita che lo scroll si ripeta ai render successivi
      window.history.replaceState({}, document.title);
    }, 100);

    return () => clearTimeout(timer);
  }, [location.state]);

  return (
    <>
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-primary to-primary/80 text-white py-20">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center">Chi Siamo e Storie</h1>
          <p className="text-xl text-center max-w-3xl mx-auto">
            L'<strong>Associazione Robin Hood Roma ODV</strong> è un'organizzazione di volontariato costituita da genitori e da pazienti con malattie ematologiche rare, 
            seguiti presso l'Ematologia, AOU Policlinico Umberto I, Sapienza Università di Roma.
          </p>{/* 
          <p className="text-xl text-center max-w-3xl mx-auto mt-4">
            L'utilità sociale e la solidarietà sono la base sui quali si è costituita l'Associazione, il cui scopo è garantire a tutti i malati 
            ‒ bambini, adolescenti e adulti ‒ di poter usufruire dell'assistenza di cui hanno bisogno.
          </p>
          <p className="text-xl text-center max-w-3xl mx-auto mt-4">
            L'idea "che nessun paziente abbia di meno" anima lo spirito dei volontari, dei soci e di tutti coloro che operano in questa Associazione.
          </p> */}
        </div>
      </div>

      {/* Mission Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center">
            <div className="md:w-1/2 mb-8 md:mb-0 md:pr-10">
              <img 
                src={logoImage} 
                alt="La nostra missione" 
                className="rounded-lg shadow-xl w-full"
              />
            </div>
            <div className="md:w-1/2">
              <h2 className="text-3xl font-bold text-primary mb-6">La Nostra Mission</h2>
              <p className="text-gray-700 mb-4">
                L'Associazione sostiene i pazienti con patologie rare ematologiche; agisce a stretto contatto con gli infermieri, 
                i medici e gli specialisti; collabora con le altre associazioni che operano nella stessa struttura. In particolare:
              </p>
              <ul className="list-disc pl-6 mb-4 text-gray-700">
                <li className="mb-2">Supporta economicamente i pazienti in difficoltà economiche per garantire le loro necessità diagnostiche e/o terapeutiche, in base al principio che nessuno abbia di meno;</li>
                <li className="mb-2">Favorisce e promuove attività di supporto ricreativo e terapie di sostegno mirate al benessere dei pazienti e dei loro familiari, nonché degli operatori della struttura;</li>
                <li className="mb-2">Facilita l'accesso ai servizi sulle malattie rare che operano in Ematologia, con un sito internet fruibile ed aggiornato, strutturato anche per favorire e promuovere la diffusione della conoscenza di queste patologie;</li>
                <li className="mb-2">Stimola e promuove i rapporti tra il personale medico, infermieristico, le famiglie e gli altri operatori del settore;</li>
                <li className="mb-2">Favorisce la ricerca nel campo delle malattie ematologiche rare:
                  <ul className="list-disc pl-6 mt-2">
                    <li className="mb-2">Promuovendo studi e ricerche sulle patologie rare di interesse ematologico;</li>
                    <li className="mb-2">Continuando a supportare infermieri, medici per convegni e/o riunioni e/o corsi di aggiornamento e di formazione sulle patologie di cui sono affetti i pazienti seguiti;</li>
                    <li className="mb-2">Finanziando premi di laurea e di specializzazione su argomenti riguardanti le malattie rare ematologiche o di interesse ematologico, destinato a studenti e specializzandi dell'Ematologia, Università Sapienza di Roma;</li>
                  </ul>
                </li>
                <li className="mb-2">Incoraggia i rapporti di collaborazione tra centri nazionali e internazionali, nonché organizzazioni ed enti che perseguono scopi analoghi.</li>
              </ul>
              <p className="text-gray-700">
                Le richieste da parte dei pazienti, dei familiari e degli operatori vengono valutate e discusse dal Consiglio Direttivo, 
                coadiuvato anche dal Comitato Scientifico. Il Consiglio Direttivo si impegna a realizzarle, reperendo fondi seguendo le 
                modalità previste dallo Statuto dell'Associazione.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* History Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-primary mb-12">La Nostra Storia</h2>
          <div className="max-w-4xl mx-auto">
            <div className="border-l-4 border-primary pl-8 mb-12 relative">
              <div className="absolute w-4 h-4 bg-primary rounded-full -left-[10px] top-2"></div>
              <h3 className="text-2xl font-semibold text-accent mb-3">2004 - La fondazione</h3>
              <p className="text-gray-700 mb-4">
                <strong>Associazione Robin Hood Roma Onlus</strong> nasce l'8 luglio 2004, per volontà di genitori dei bambini e degli adolescenti, 
                seguiti presso l'Ematologia Pediatrica dell'Ematologia, AOU Policlinico Umberto I, Sapienza Università di Roma, 
                in linea con le direttive dell'AIEOP (Associazione Italiana di Ematologia e Oncologia Pediatrica).
              </p>
              <p className="text-gray-700 mb-4">
                Dalla sua fondazione fino all'ottobre 2022, l'Associazione ha potuto svolgere la propria mission grazie al generoso 
                supporto di genitori, pazienti e amici: ha aiutato economicamente famiglie di pazienti in difficoltà; ha acquistato 
                presidi medicali indispensabili per il buon funzionamento dell'assistenza per i bambini; ha acquistato letti per i 
                genitori dei piccoli pazienti ricoverati; ha supportato il personale medico e infermieristico nei corsi di formazione 
                e di aggiornamento; ha finanziato una psicologa per l'attività clinica; ha sostenuto le attività delle nove edizioni 
                del «Master in Ematologia Pediatrica» istituito dalla Sapienza Università di Roma; e ha curato la stampa annuale di 
                un calendario con disegni realizzati dai pazienti pediatrici.
              </p>
            </div>
            
            <div className="border-l-4 border-primary pl-8 mb-12 relative">
              <div className="absolute w-4 h-4 bg-primary rounded-full -left-[10px] top-2"></div>
              <h3 className="text-2xl font-semibold text-accent mb-3">2022 - La trasformazione</h3>
              <p className="text-gray-700 mb-4">
                Nell'ottobre 2022, con la chiusura del reparto pediatrico e le dimissioni irrevocabili dello storico presidente, 
                Aldo Spinella, è stato deciso di proseguire l'attività dell'Associazione focalizzando l'attenzione nel supportare 
                i pazienti con patologie rare ematologiche di qualsiasi età (bambini, adolescenti e adulti) affetti da malattie 
                rare ematologiche.
              </p>
              <p className="text-gray-700 mb-4">
                Trasmigrata nel RUNTS (Registro Unico Nazionale Terzo Settore) nel novembre 2022, l'«Associazione Robin Hood Roma Onlus» 
                è diventata, nel marzo 2024, una ODV, con un nuovo statuto ed ha acquisito personalità giuridica.
              </p>
            </div>
            
            <div className="border-l-4 border-primary pl-8 relative">
              <div className="absolute w-4 h-4 bg-primary rounded-full -left-[10px] top-2"></div>
              <h3 className="text-2xl font-semibold text-accent mb-3">Oggi</h3>
              <p className="text-gray-700">
                Dal 2022 a oggi, l'Associazione ha continuato a sostenere economicamente e a migliorare l'assistenza ai pazienti 
                con malattie rare seguiti in Ematologia: con l'acquisto di dispositivi medici (come elettrocardiografi, reagenti, etc); 
                a supportare medici e infermieri per migliorare la loro professionalità in ambiti specifici (trapianto di cellule 
                staminali e terapie innovative, etc).
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Storie di Impatto */}
      <section id="storie-di-impatto" className="py-16 bg-white scroll-mt-24">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-primary mb-12">Storie di Impatto</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <ImpactStory
              image={fotoMonica}
              title="La storia di Monica"
              description={`Mi chiamo Monica Oriente e sono autrice del libro "Quattro volte me \u2013 Le mie rinascite dopo il cancro". All'età di vent'anni ho ricevuto la mia prima diagnosi di cancro, un linfoma di Hodgkin al IV stadio.`}
              fullText={`Mi chiamo Monica Oriente e sono autrice del libro "Quattro volte me – Le mie rinascite dopo il cancro".

All'età di vent'anni ho ricevuto la mia prima diagnosi di cancro, un linfoma di Hodgkin al IV stadio, successivamente una recidiva con autotrapianto di midollo osseo. Molti anni dopo ho affrontato altre due diagnosi oncologiche, un carcinoma al seno e un carcinoma della tiroide. Ho cercato di trasformare ogni esperienza di malattia in un percorso di consapevolezza, forza e rinascita. Ho scelto di raccontare la mia storia per testimoniare che la malattia non definisce una persona, ma può diventare occasione di empatia e nuova luce.

Sintetica descrizione del libro

"Quattro volte me" è il racconto intimo e autentico di quattro cancri, e di altrettante rinascite. Non è solo la storia della malattia, ma il viaggio emotivo di una donna che ha scelto di restare protagonista della propria vita anche nei momenti più fragili.

Tra ospedali, paure, cicatrici e piccoli gesti di salvezza, il libro parla di empatia, di identità, di forza silenziosa e della capacità di trasformare ogni crepa con l'oro, proprio come nel kintsugi, insomma un modo in cui ricomporre la propria esistenza.

Due brevi passaggi significativi

"La testa nuda poggiata sul cuscino. Il silenzio che amplifica ogni respiro.
Non stavo solo perdendo i miei capelli, stavo lasciando andare una parte di me.
Eppure, in quella fragilità, c'era una forma diversa di forza che non avevo mai conosciuta."

"Il cancro non è solo una malattia. È un'ombra che cambia tutto.
Ma come tutte le ombre, esiste solo perché c'è una luce.
E quella luce, anche nei giorni più bui, non si spegne."`}
            />
            <ImpactStory
              image={fotoCinqueStorie}
              title="Cinque voci, cinque storie"
              description={`Estratti della conversazione tra Silvia Finocchi, psicologa e psicoterapeuta, e cinque autori, svoltasi nell'ambito dell'incontro "La Malattia non è tutta la storia" del 7 marzo 2026.`}
              fullText={`CINQUE VOCI, CINQUE STORIE

Estratti della conversazione tra Silvia Finocchi, psicologa e psicoterapeuta, e cinque autori, svoltasi nell'ambito dell'incontro "La Malattia non è tutta la storia" del 7 marzo 2026. Tutti i partecipanti condividono un denominatore comune: un'esperienza diretta con l'ematologia, in qualità di pazienti o di professionisti, tra cui insegnanti, medici e biologi.

Marco Marziali, medico Immunologo, si occupa di malattie ematologiche e trapianto di midollo osseo presso il Policlinico Umberto I Roma. Oltre a "Il donatore di musica", ha pubblicato "La Quarta Ballata" e "Preludi".

Il donatore di musica si basa sulla storia vera di un trapianto e si intreccia con altre vicende. Nella conversazione, l'autore ha affermato che la sua passione per la musica lo accompagna fin dalla nascita e che la scelta di intraprendere la professione medica è stata dettata principalmente da motivi pratici, suggeriti dal padre. Dal punto di vista del suo sentire, musica e medicina si compensano e si completano: la medicina gli ha insegnato a osservare il corpo, mentre la musica e la scrittura gli hanno insegnato ad ascoltare la persona. Insieme, queste esperienze lo hanno aiutato a comprendere che un paziente non è soltanto un dato clinico, ma una storia fatta di emozioni, fragilità e speranze. Arte e scienza, secondo l'autore, ricordano che la persona è molto più della malattia: la scienza cura il corpo, mentre l'arte aiuta a dare senso all'esperienza e a mantenere viva la dimensione umana della vita. In ambito ospedaliero, la musica può diventare uno spazio di sollievo e di ascolto interiore. Non sostituisce la cura medica, ma contribuisce a ritrovare un equilibrio tra mente e corpo e a sentirsi ancora persone, non soltanto pazienti.

Emiliano Battazzi, scrive per «Ultimo Uomo», rivista digitale incentrata sullo sport e la sua narrazione. È coautore del podcast «Icone», dedicato ai più grandi calciatori della storia. Ha collaborato tra gli altri con «Undici», «Esquire» e la rivista spagnola «The Tactical Room». È tra gli autori della Caduta dei campioni. Storie di sport tra la gloria e l'abisso. Con Calcio liquido- l'evoluzione tattica della serie A, di cui è appena uscita una nuova edizione aggiornata, ha vinto il premio letterario Coni 2021. Nel 2025 ha pubblicato anche Vincere la Champions.

Calcio liquido-l'evoluzione tattica della serie A è un racconto che attraversa l'evoluzione del calcio per parlare di cambiamento, identità e movimento, dentro e fuori dal campo.

L'autore ritiene che lo sport, e il calcio in particolare, sia un linguaggio attraverso cui si racconta molto più del semplice gioco. Nelle tattiche, negli stili e nelle rivoluzioni tecniche si riflettono infatti cambiamenti culturali, sociali e generazionali. Raccontare il calcio significa spesso raccontare anche i diversi tipi di società e il modo in cui cambiano e si influenzano. Egli sostiene inoltre che la scrittura possa modificare lo sguardo del lettore: dopo aver letto determinate storie o analisi, si inizia a osservare una partita con maggiore attenzione, cogliendo non solo il risultato, ma anche i movimenti, le scelte e le idee dietro ogni gesto. In questo senso, il lettore diventa uno spettatore più consapevole. A suo avviso, il calcio è in continua evoluzione, ma il racconto ha la capacità di fermare tali cambiamenti e attribuire loro un significato. Attraverso il calcio è possibile riflettere su temi più ampi, come l'identità, la trasformazione e il futuro. Raccontarlo significa anche offrire uno spazio per comprendere meglio il presente e immaginare ciò che verrà.

Mario Cistulli è stato docente di Scienze Motorie e Sportive per 17 anni presso la sezione ospedaliera di Ematologia, AOU Policlinico Umberto I, del Liceo Scientifico "Tullio Levi-Civita". Insegnante e formatore di yoga secondo la tradizione di T.K.V. Desikachar, ha svolto un periodo di studio di quindici mesi in India presso il Krishnamacharya Yoga Mandiram, approfondendo l'applicazione dello yoga nella scuola. Ha collaborato con enti e università e partecipato a progetti del Ministero dell'Istruzione, dedicandosi in particolare all'uso dello yoga nel contesto sociale e scolastico.

Educazione fisica nella scuola in ospedale è una testimonianza diretta di un approccio educativo che integra corpo, cura e relazione, mettendo al centro la persona e il suo benessere. L'autore ha rilevato come l'equilibrio tra obiettivi educativi e bisogni terapeutici nasce dal dialogo costante con l'équipe medica. Di conseguenza, l'attività motoria viene adattata alle condizioni di ogni paziente, diventando non solo esercizio fisico, ma uno strumento per sostenerne il benessere, la motivazione e il senso di normalità durante il percorso di cura.

Ha sottolineato che ad un'attività che coinvolge il corpo, il paziente può manifestare rifiuto o paura, soprattutto all'inizio, perché la malattia rende il corpo una dimensione delicata e a volte difficile da affrontare. Con il tempo, però, grazie alla relazione di fiducia e a un approccio graduale, molti ragazzi scoprono nuove risorse in sé stessi e recuperano un rapporto più positivo con il proprio corpo.

Ha ribadito che l'esperienza della scuola in ospedale mostra quanto sia importante considerare la persona nella sua interezza.

Luca Laurenti, biologo presso il Policlinico Umberto I di Roma, è anche uno scrittore di novelle per ragazzi e racconti. Nel 2007, con il libro Viae Crucis ha vinto il premio Targa "Il Molinello"; nel 2021 ha ottenuto il primo premio al concorso nazionale Quando incontrai Dante.

Oltre a Lockdown fase 1- diario di un'apocalisse, ha pubblicato Le avventure di Ponchito e Rodríguez e Il Prescelto, romanzi per ragazzi; Sul lago Escondido e Viae Crucis, raccolta di racconti; il libro-racconto L'ultima lettera; i romanzi Il mondo di Samira - Memorie di una kamikaze palestinese, L'estate di Serena e La tonaca del prete; Il DNA per i più piccoli e Viaggio nella cellula, libri per ragazzi; il romanzo-diario All'ombra dell'Illimani, il dossier fotografico Il vento sta cambiando? in collaborazione con Roberto Lattanzi, la raccolta di cronache Uomini, luoghi, emozioni, e Dodici racconti.

Lockdown fase 1, è una cronaca lunga 55 giorni, quelli in cui l'Italia viene dichiarata zona rossa per circoscrivere il COVID-19. La sensibilità dell'autore annota impressioni e fatti dell'evento epocale e ricordi personali, riuscendo a trasmettere al lettore la bellezza contrastante delle piccole cose, quelle solitamente rese invisibili dalla normale quotidianità.

L'autore ritiene che le crisi abbiano la capacità di rallentare lo sguardo e far riscoprire ciò che normalmente si dà per scontato. Durante il lockdown molti gesti semplici, come una passeggiata, una conversazione o la luce che entra dalla finestra, hanno riacquistato un valore speciale. Secondo lui, libri come questo possono servire proprio a questo: conservare la memoria di quel tempo sospeso. Non solo per ricordare la paura, ma anche per sottolineare la maggiore attenzione verso se stessi, gli altri e il tempo che sembrava scorrere più lentamente. L'autore ha manifestato la speranza che chi leggerà il libro in futuro percepisca soprattutto la dimensione umana di quei giorni: la fragilità, certo, ma anche la capacità delle persone di cercare senso, relazione e speranza anche in situazioni difficili e inattese.

Monica Oriente, con il suo libro Quattro volte me, ha sottolineato come la scrittura le abbia permesso di ricordare che la malattia è solo una parte della storia di una persona e che nessuno dovrebbe sentirsi solo nel proprio percorso. Dal dialogo con Silvia Finocchi è emerso che la diagnosi di cancro può diventare un'etichetta, rischiando di identificare la persona con la malattia. Raccontare la propria storia è stato per l'autrice un modo per ricordare — a sé stessa e agli altri — che la malattia non definisce chi siamo. Ha anche espresso l'emozione nel rendersi conto che le sue parole potrebbero far sentire qualcuno meno solo o più compreso, dando un senso ancora più profondo alle esperienze vissute. Il bene più prezioso, secondo Monica, è stato non sentirsi mai sola, grazie al sostegno delle persone care. Anche nei momenti più difficili, chi le è stato accanto ha stimolato la sua forza e il suo coraggio, permettendole di vivere con consapevolezza e gioia ogni momento della vita e alimentando la speranza per continuare a sognare.

Ogni storia è unica, ma nessuno dovrebbe sentirsi isolato nel proprio cammino.`}
            />
            <ImpactStory
              image={fatimaCard}
              title="La storia di Fatima"
              description="Aveva solo pochi mesi quando la nostra bambina si è ammalata di una malattia per noi sconosciuta, una malattia che ha messo seriamente in pericolo la sua vita. Siamo partiti da casa senza sapere cosa stesse accadendo, pieni di paura, smarriti, con il cuore in gola."
              fullText={`Aveva solo pochi mesi quando la nostra bambina si è ammalata di una malattia per noi sconosciuta, una malattia che ha messo seriamente in pericolo la sua vita. Siamo partiti da casa senza sapere cosa stesse accadendo, pieni di paura, smarriti, con il cuore in gola.

Mai avremmo immaginato di trovare una nuova casa proprio lì, nel Reparto di Ematologia Pediatrica del Policlinico Umberto I di Roma. Un luogo dove medici e infermieri indossano camici colorati e sorrisi rassicuranti, e dove, giorno dopo giorno, abbiamo ritrovato la speranza di salvare la nostra piccola Fatima.

L'abbiamo affidata a loro e ci siamo fidati completamente. In particolare, della nostra dottoressa del cuore, Fiorina Giona: con un abbraccio, uno sguardo dolce, i suoi occhi azzurri, non ha mai mollato la nostra mano. Nemmeno quando le cure sembravano non funzionare e quella malattia rara, così strana e crudele, continuava ad accanirsi su una creatura così piccola.

È stata la ricerca a salvarci. Grazie a un farmaco nuovo, sperimentale, abbiamo potuto iniziare davvero a combattere. E a combattere non c'era solo Fatima: c'eravamo noi genitori, i medici, tutto il personale sanitario e la farmacista che preparava il farmaco con il dosaggio preciso. Uniti, insieme, ce l'abbiamo fatta.

Credo profondamente nella ricerca. Credo che possa salvare tanti bambini, come ha salvato Fatima. Oggi, a distanza di sette anni, ripenso a quel periodo non con amarezza, ma con il cuore colmo di gratitudine. Gratitudine verso Dio, per averci fatto incontrare la nostra dottoressa Giona, e insieme a lei la dottoressa Giovanna Palumbo.

Ogni sei mesi, quando torniamo per i controlli, è come tornare un po' a casa. Quella casa che ci ha restituito la vita.

Un ringraziamento speciale alla dottoressa Fiorina Giona, alla dottoressa Giovanna Palumbo, alla dottoressa Moleti, alla dottoressa Testi e a tutti gli infermieri del reparto di Ematologia Pediatrica di via Benevento, a Roma.

Con infinita riconoscenza,
Mamma, Papà e Fatima ❤️❤️`}
            />
            <ImpactStory
              image={pierluigiCopertina4}
              title="La storia di Pierluigi"
              description="Nel 1987 sono stato ricoverato in Ematologia, Policlinico Umberto I di Roma per una rara forma di leucemia acuta. A distanza di anni, mi ricordo ancora la sensazione che ho avuto, appena varcata la soglia: sentirmi completamente a mio agio, come se fossi a casa."
              fullText={`Nel 1987 sono stato ricoverato in Ematologia, Policlinico Umberto I di Roma per una rara forma di leucemia acuta. A distanza di anni, mi ricordo ancora la sensazione che ho avuto, appena varcata la soglia: sentirmi completamente a mio agio, come se fossi a casa.

La mia frequentazione, in reparto e in ambulatorio, mi ha confermato questa sensazione, dovuta al calore umano di tutto il personale e dei volontari. Sono rimasto colpito anche dall'organizzazione, e dall'abnegazione dei medici e infermieri, disponibili e attivi con competenza nel non facile impegno di alleviare le nostre sofferenze. Una professionalità e umanità determinante per la serenità dei pazienti e dei genitori.

Si sa che ogni individuo ha il suo modo di affrontare la malattia; la mia singolare esperienza mi ha permesso di fronteggiarla con positività e determinazione. Oggi, dopo quasi quarant'anni, sento una gratitudine nei confronti della vita, che, attraverso questa malattia, mi ha dato l'opportunità di ricominciare a vivere con un altro spirito.

Scrivere … con la mano che volteggiava sui fogli bianchi è stata per me una sorgente di riflessione, mentre come un equilibrista vagavo sul filo labile della vita. Ho scritto fiumi di parole che mi hanno aiutato ad entrare nel mio mondo interiore, donandomi una chiave di lettura nell'interpretazione del vero senso della vita. Ho pubblicato tre libri, ma continuo a scrivere.

Oggi ho il privilegio di essere un socio e volontario dell'associazione Robin Hood Roma ODV, un'Associazione di pazienti per i pazienti. Un ritorno a casa, onorato e felice di poter dare il mio contributo con sensibilità e riconoscenza alla Vita.

Pierluigi Girolami`}
            />
            <ImpactStory
              image={fotoAntonella1}
              title="La storia di Antonella"
              description="Sono Antonella, e sono una paziente dell'Ematologia. Lo sono da abbastanza tempo da esser cresciuta attraverso tutti i suoi cambiamenti nel corso degli anni. La fotografia è la mia passione e attraverso di essa trasmetto l'amore per la vita."
              fullText={`Sono Antonella, e sono una paziente dell'Ematologia. Lo sono da abbastanza tempo da esser cresciuta attraverso tutti i suoi cambiamenti nel corso degli anni. Avere una malattia rara (congenita) non rende la vita facile. Spesso le rinunce sono tante. Ma il tempo è uno straordinario alleato.

Quello che la Ricerca è riuscita a realizzare nell'ultimo decennio è straordinario. Da gran parte delle malattie rare non si guarisce (ancora) ma il lavoro, la dedizione e la tenacia di medici e ricercatori sono la speranza di noi pazienti. Da quando ero piccolissima, loro sono stati la mia seconda famiglia. Lo sono ancora oggi.

L'amore per la vita, che la malattia ha solo rafforzato, cerco di trasmetterlo attraverso la fotografia, che è la mia passione. E le cose belle vanno sempre condivise perché possano germogliare nel cuore degli altri. Per me la fotografia è 'fermare' la realtà. Ho iniziato a scattar foto più di vent'anni fa, quasi per caso.

Camminare e fotografare fa bene al fisico e alla mente. Le foto sono istanti fermati per sempre. Un frammento di vita che fa rivivere l'emozione di quel momento passato, nel tempo. Basta saperli cogliere e farne tesoro.`}
            />
            <ImpactStory
              image={emilianoBattanzi}
              title="La storia di Emiliano"
              description="Tutto è iniziato da bambino, nelle sale d'attesa dell'Ematologia Pediatrica a Roma, dove ho scoperto una passione totalizzante per il calcio. Quelle letture sono diventate il seme di un percorso che mi ha portato a scrivere Calcio liquido."
              fullText={`Non so quante ore debba aver passato, da bambino, nella sala d'attesa e nelle varie stanze dell'Ematologia Pediatrica dell'Ematologia di Via Benevento 6 di Roma, di sicuro meno di 10mila, ma in qualcosa sono diventato bravo. A leggere, soprattutto: mi portavo sempre qualche giornale e rivista da leggere. Di solito, riviste sportive, ad esempio il Guerin Sportivo.
Secondo la celebre teoria delle 10mila ore, formulata dal sociologo canadese Malcolm Gladwell, per diventare bravi in qualcosa bisogna applicarsi intensamente, per circa 10mila ore, appunto.
Se questo è vero sono diventato bravo nel calcio, so tutto di quello che è stato scritto. Ogni fotogramma è nella mia testa. So cosa hanno scritto le penne più importanti. Anche oggi, che sono nel settore giornalistico calcistico, so che la mia passione quasi maniacale per il calcio è nata lì tra le cure, le attenzioni ricevute in Ematologia Pediatrica del Policlinico Umberto I di Roma.
Trent'anni dopo il mio primo ingresso a Via Benevento 6, è uscito nelle librerie, pubblicato dall'editore 66thand2nd, il mio libro Calcio liquido. L'evoluzione tattica della Serie A.
Il libro parte da un aforisma del celebre allenatore Vujadin Boškov, che recita così: "i giocatori vincono, gli allenatori perdono". Calcio liquido racconta la storia del calcio vista dalla parte degli allenatori, ripercorrendo gli ultimi trent'anni di evoluzione tattica della Serie A, partendo dalla rivoluzione di Arrigo Sacchi. Il libro ripercorre, con un linguaggio chiaro e accessibile, i momenti decisivi delle grandi squadre italiane e le idee degli allenatori più importanti del campionato: da Sacchi a Capello, da Zeman a Lippi, da Spalletti a Mourinho, da Ancelotti a Sarri, fino a Conte, Gasperini, Allegri, Inzaghi e Mancini. Modi diversi di pensare il calcio. In ogni fase in cui il movimento calcistico italiano sembra arretrato, si intravede una speranza di rinnovamento e di successo futuro.

La teoria delle 10mila ore di Gladwell è poi stata smentita dalla letteratura scientifica, ma per me è ancora valida. Durante le lunghe attese in Ematologia ho considerato la lettura di argomenti riguardanti il calcio una dolce compagnia che mi ha poi permesso di poter esprimere quanto recepito e fatto mio. Alla pubblicazione del mio libro, ho voluto condividere questo evento emozionante con i medici che mi avevano seguito in un momento impegnativo della mia infanzia. E' stato, poi, naturale per me essere coinvolto e sostenere l'Associazione Robin Hood Roma, per restituire un po' di quello che sento di aver ricevuto.`}
              imageStyle={{ objectPosition: 'center 35%' }}
            />
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-16 bg-primary text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-6">Unisciti alla Nostra Causa</h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto">
            Ogni giorno lavoriamo per migliorare la vita delle persone affette da malattie ematologiche rare. Con il tuo supporto, possiamo fare ancora di più.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <a 
              href="/sostienici" 
              className="inline-block bg-white text-primary hover:bg-gray-100 font-medium py-3 px-6 rounded-lg transition-colors"
            >
              Fai una Donazione
            </a>
            <a 
              href="/contatti" 
              className="inline-block bg-accent text-white border border-white hover:bg-accent/90 font-medium py-3 px-6 rounded-lg transition-colors"
            >
              Contattaci
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default ChiSiamo;
